import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import UserContext from './contexts/UserContext'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <UserContext>
    <ToastContainer position='top-center' />
    <App />
  </UserContext>
)
